import {Container} from "./Container"

export const SignUpStyles = {
    Container: Container
}